import React from "react";

const Line2 = ({ prop }) => {
  return <div className={`bg-primary h-0.5 w-10 ${prop}`}></div>;
};

export default Line2;
